import { render, staticRenderFns } from "./fee_config_list.vue?vue&type=template&id=f2fa3568&scoped=true"
import script from "./fee_config_list.vue?vue&type=script&lang=js"
export * from "./fee_config_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2fa3568",
  null
  
)

export default component.exports